import React from 'react';
import PropTypes from 'prop-types';
import AbstractInput from '../AbstractInput';
import { MaskInput } from '../index';
import bindMultiple from '../../../common/helpers/bindMultiple';

class ZipInput extends React.Component {
  static propTypes = {
    ...AbstractInput.propTypes,
    onChange: PropTypes.func,
  };

  constructor(props) {
    super(props);

    bindMultiple(this, this.handleCommit);
  }

  handleCommit(stringValue) {
    // Override behaviour by Higher order Component
    if (typeof this.props.onCommit === 'function') {
      return this.props.onCommit(stringValue);
    }

    // Else use default behaviour
    if (typeof this.props.onChange === 'function') {
      this.props.onChange(stringValue.trim());

      return true;
    }

    return false;
  }

  render() {
    const classNames = ['zip-input-field'];

    if (typeof this.props.className === 'string' && this.props.className.trim() !== '') {
      classNames.push(this.props.className);
    }

    return (
      <MaskInput {...this.props} mask={'#####-####'} className={classNames.join(' ')} onCommit={this.handleCommit} />
    );
  }
}

export default ZipInput;
